import { addPageAction, sanitizeAttributes } from 'modules/core/monitoring';

type EventLoggerInput = {
	name?: string;
	message: string;
	extra?: Record<string, unknown>;
};

const eventLogger = (input: EventLoggerInput): void => {
	addPageAction(input.name ?? 'event', {
		message: input.message,
		...sanitizeAttributes(input.extra),
	});
};

export default eventLogger;
